import React from "react";

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Hero Section */}
      <header className="bg-gradient-to-r from-blue-900 via-indigo-900 to-purple-900 py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            Worldwide Seafarers Recruitment Network
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-4">
            Your Voyage. Our Mission.
          </p>
          <p className="text-lg text-gray-400 italic mb-8">
            Portugal is our harbor—but the world is our ocean.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-4">
            <a href="/register" className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg font-semibold transition">
              Register as Seafarer
            </a>
            <a href="/dashboard" className="bg-gray-700 hover:bg-gray-600 px-6 py-3 rounded-lg font-semibold transition border border-gray-600">
              Access Dashboard
            </a>
          </div>
        </div>
      </header>

      {/* Lisbon Banner */}
      <section className="relative h-[60vh] bg-cover bg-center" style={{ backgroundImage: "url('/images/lisbon-msc.jpg')" }}>
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center text-center text-white px-6">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2">From Lisbon to the World</h2>
            <p className="text-lg md:text-xl max-w-2xl mx-auto">
              Rooted in Portugal’s maritime legacy, WSRN carries forward the spirit of exploration, trade, and unity—connecting people, purpose, and ports across the globe.
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 px-6 bg-gray-800">
        <div className="max-w-5xl mx-auto space-y-8">
          <h2 className="text-3xl font-bold">A Calling Rooted in Service</h2>
          <p className="text-gray-300 text-lg leading-relaxed">
            Born in Curaçao and shaped by life in the Netherlands, I now call Portugal home. Here, on the edge of the Atlantic, I’ve found the perfect harbor to launch a mission that blends entrepreneurship with spiritual purpose.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed">
            WSRN is more than a platform—it is a vessel of service. Guided by values of integrity, unity, and divine alignment, this project is my offering to Portugal’s future and the global maritime community.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed font-semibold italic">
            No one is above the other. We are one crew, one current, one calling.
          </p>
        </div>
      </section>

      {/* Platform Vision */}
      <section className="py-16 px-6 bg-gray-900">
        <div className="max-w-5xl mx-auto space-y-10">
          <h2 className="text-3xl font-bold">Our Mission</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              <p className="text-gray-300 text-lg">
                WSRN is an innovative, responsible, and sustainable platform that strengthens Portugal’s role in the global maritime industry.
              </p>
              <p className="text-gray-300 text-lg">
                With a firm belief in the transformative potential of technology and AI, our vision is to streamline recruitment, legal procedures, and payroll management for seafarers and shipping companies worldwide.
              </p>
              <p className="text-gray-300 text-lg">
                Our dedication, grounded in spiritual values, fuels an unwavering commitment to uphold Portuguese laws, contribute to the local economy, and help Portugal become a leader in maritime staffing and innovation.
              </p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg space-y-4">
              <h3 className="text-xl font-semibold">Platform Highlights</h3>
              <ul className="mt-4 space-y-3 text-gray-300">
                <li>• AI-Powered Matching</li>
                <li>• Legal Processing (Visa, NIF, SEF, AIMA)</li>
                <li>• Payroll Compliance</li>
                <li>• Video Interview Tool</li>
                <li>• Training Center Integration</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-400 py-8 text-center mt-16">
        <p className="text-white font-semibold">Portugal is our harbor—but the world is our ocean.</p>
        <p className="mt-2 text-sm">© {new Date().getFullYear()} WSRN – Built with ❤️ in Portugal</p>
        <p className="text-sm">For global maritime staffing and legal compliance under Portuguese Law</p>
        <div className="mt-6 flex justify-center gap-6">
          <a href="/about" className="hover:text-blue-400">About Us</a>
          <a href="/legal" className="hover:text-blue-400">Legal Process</a>
          <a href="/dashboard" className="hover:text-blue-400">Admin Dashboard</a>
        </div>
      </footer>
    </div>
  );
}

